export default {
  name: "CourseMapping",
  computed: {
    positionCompetencyMappingData() {
      return this.$store.getters["courseMapping/getPositionCompetencyMappings"] || [];
    },
    totalItems() {
      return this.$store.getters["courseMapping/getTotalItems"] || 0;
    },
    isLoading() {
      return this.$store.getters["courseMapping/getLoading"];
    },
    positionOptions() {
      return this.$store.getters["position/getPositions"] || [];
    },
    competencyOptions() {
      return this.$store.getters["competency/getCompetencies"] || [];
    },
    // Filter options from the new filter store
    departmentOptions() {
      const departments = this.$store.getters["courseMappingFilters/getDepartments"] || [];
      return departments.map(item => ({
        value: item.department,
        label: item.department
      }));
    },
    divisionOptions() {
      const divisions = this.$store.getters["courseMappingFilters/getDivisions"] || [];
      return divisions.map(item => ({
        value: item.division,
        label: item.division
      }));
    },
    filterPositionOptions() {
      const positions = this.$store.getters["courseMappingFilters/getPositions"] || [];
      return positions.map(item => ({
        position_id: item.position_id,
        position_title: item.position_title
      }));
    },
    employeeOptions() {
      const employees = this.$store.getters["courseMappingFilters/getEmployees"] || [];
      return employees.map(item => ({
        nik: item.nik || item.nik,
        employee_name: item.employee_name || item.name || item.fullname || item.full_name
      }));
    },
    // Training data
    trainings() {
      return this.$store.getters["courseMappingFilters/getTrainings"] || [];
    },
    trainingsPagination() {
      return this.$store.getters["courseMappingFilters/getTrainingsPagination"] || { total: 0, page: 1, limit: 10, totalPage: 0 };
    },
    selectedTrainings() {
      return this.$store.getters["courseMappingFilters/getSelectedTrainings"] || [];
    },
    isTrainingLoading() {
      return this.$store.getters["courseMappingFilters/getLoading"]('trainings');
    },
    isSaving() {
      return this.$store.getters["courseMappingFilters/getLoading"]('saving');
    },
    allTrainingsSelected() {
      if (this.trainings.length === 0) return false;
      return this.trainings.every(training => this.isTrainingSelected(training.id));
    },
    // Exclude filter options
    excludeDepartmentOptions() {
      const departments = this.$store.getters["courseMappingFilters/getDepartments"] || [];
      return departments.map(item => ({
        value: item.department,
        label: item.department
      }));
    },
    excludePositionOptions() {
      const positions = this.$store.getters["courseMappingFilters/getPositions"] || [];
      return positions.map(item => ({
        position_id: item.position_id,
        position_title: item.position_title
      }));
    },
    excludeEmployeeOptions() {
      const employees = this.$store.getters["courseMappingFilters/getEmployees"] || [];
      return employees.map(item => ({
        nik: item.nik || item.nik,
        employee_name: item.employee_name || item.name || item.fullname || item.full_name
      }));
    }
  },
  data() {
    return {
      listTabMenu: {
        privilages: {
          create: true,
          read: true,
          update: true,
          delete: true
        }
      },
      body: {
        page: 1,
        limit: 10,
        search: "",
        order: ""
      },
      filters: {
        division: "",
        department: "", 
        name: "",
        position_id: "",
        course: "",
        search: ""
      },
      excludeFilters: {
        departments: [],
        positions: [],
        employees: []
      },
      bodyAdd: {
        position_id: "",
        competency_id: "",
        role_id: "",
        required: false
      },
      viewDetailData: {},
      isAdd: true,
      modalTitle: "Add Course Mapping",
      searchTimeout: null,
      employeeSearchTimeout: null,
      excludeEmployeeSearchTimeout: null,
      showTrainingTable: false,
      selectedFile: null,
      isUploading: false,
      isDownloading: false,
      trainingColumns: [
        {
          label: "ID",
          field: "training_id",
          thClass: "table-header text-muted font-weight-bold",
          tdClass: "color-secondary align-middle",
          width: "20%"
        },
        {
          label: "COURSE",
          field: "title",
          thClass: "table-header text-muted font-weight-bold",
          tdClass: "color-secondary align-middle",
          width: "50%"
        },
         {
          label: "ROLE ID",
          field: "role_id",
          thClass: "table-header text-muted font-weight-bold",
          tdClass: "color-secondary align-middle",
          width: "20%"
        },
        // {
        //   label: "PROVIDER",
        //   field: "provider_name",
        //   thClass: "table-header text-muted font-weight-bold",
        //   tdClass: "color-secondary align-middle",
        //   width: "18%"
        // },
        // {
        //   label: "METHOD",
        //   field: "training_method",
        //   thClass: "table-header text-muted font-weight-bold",
        //   tdClass: "color-secondary align-middle",
        //   width: "15%"
        // },
        // {
        //   label: "HOUR",
        //   field: "hour",
        //   thClass: "table-header text-muted font-weight-bold",
        //   tdClass: "color-secondary align-middle",
        //   width: "8%"
        // },
        // {
        //   label: "TYPE",
        //   field: "training_type",
        //   thClass: "table-header text-muted font-weight-bold",
        //   tdClass: "color-secondary align-middle",
        //   width: "12%"
        // },
        {
          label: "REQUIRED",
          field: "required",
          thClass: "table-header text-muted font-weight-bold",
          tdClass: "color-secondary align-middle",
          width: "10%"
        }
      ]
    };
  },
  mounted() {
    this.loadFilterOptions();
    
    // Don't load trainings initially - wait for filters to be filled
    // this.loadTrainings();
    
    // Hide training table initially
    this.showTrainingTable = false;
    
    // Set menu permissions
    this.setMenuPermissions();
  },
  beforeDestroy() {
    clearTimeout(this.searchTimeout);
    clearTimeout(this.employeeSearchTimeout);
    clearTimeout(this.excludeEmployeeSearchTimeout);
  },
  methods: {
    // Set menu permissions
    setMenuPermissions() {
      const listMenu = JSON.parse(localStorage.getItem('listMenu') || '[]');
      const currentPath = window.location.pathname;
      const menu = listMenu.find((menu) =>
        menu.link === String(currentPath) || menu.children.some((child) => child.link === String(currentPath))
      );
      this.listTabMenu = menu ? menu.children.find((item) => item.link === currentPath) || menu : {};
    },

    // Helper methods
    getPositionName(positionId) {
      const position = this.positionOptions.find(p => p.id === positionId || p.position_id === positionId);
      return position ? (position.position_title || position.name) : positionId;
    },

    getCompetencyName(competencyId) {
      const competency = this.competencyOptions.find(c => c.id === competencyId);
      return competency ? competency.name : competencyId;
    },

    getRoleDescription(roleId) {
      const roles = {
        'PO': 'Pengawas Operasional',
        'PT': 'Pengawas Teknis',
        'TT': 'Tenaga Teknis'
      };
      return roles[roleId] || roleId;
    },

    // Filter API methods
    async loadFilterOptions() {
      await Promise.all([
        this.$store.dispatch("courseMappingFilters/fetchDivisions"),
        this.$store.dispatch("courseMappingFilters/fetchDepartments"),
        this.$store.dispatch("courseMappingFilters/fetchPositions")
      ]);
    },

    async refreshMappingByFilters() {
      this.$store.dispatch("courseMappingFilters/clearSelectedTrainings");

      if (!this.hasActiveMappingFilter()) {
        this.showTrainingTable = false;
        return;
      }

      if (!this.showTrainingTable) {
        await this.loadTrainings();
        this.showTrainingTable = true;
      }

      await this.loadTrainingMapping();
    },

    hasActiveMappingFilter() {
      return Boolean(
        this.filters.division ||
        this.filters.department ||
        this.filters.position_id ||
        this.filters.name
      );
    },

    async loadDivisions() {
      await this.$store.dispatch("courseMappingFilters/fetchDivisions");
    },

    async loadDepartments() {
      await this.$store.dispatch("courseMappingFilters/fetchDepartments");
    },

    async onDivisionChange() {
      // Independent filters: do not clear/reload other filter options
      await this.refreshMappingByFilters();
    },

    async onDepartmentChange() {
      // Independent filters: do not clear/reload other filter options
      await this.refreshMappingByFilters();
    },

    async onPositionChange() {
      // Independent filters: keep Division/Department/Employee selections as-is
      await this.refreshMappingByFilters();
    },

    // Employee selection change
    async onEmployeeChange() {
      await this.refreshMappingByFilters();
    },

    onEmployeeSearch(search, loading) {
      clearTimeout(this.employeeSearchTimeout);

      if (!search || search.length < 2) {
        this.$store.dispatch("courseMappingFilters/clearEmployees");
        return;
      }

      if (loading) loading(true);
      this.employeeSearchTimeout = setTimeout(async () => {
        try {
          // Search BIB employees freely — no sequential parent filter required
          await this.$store.dispatch("courseMappingFilters/fetchEmployees", { search });
        } finally {
          if (loading) loading(false);
        }
      }, 350);
    },

    // Exclude filter methods
    async onExcludeDepartmentChange() {
      // Keep main Position options intact (shared store); only reset exclude dependents
      this.excludeFilters.positions = [];
      this.excludeFilters.employees = [];
    },

    async onExcludePositionChange() {
      this.excludeFilters.employees = [];
    },

    onExcludeEmployeeSearch(search, loading) {
      clearTimeout(this.excludeEmployeeSearchTimeout);

      if (!search || search.length < 2) {
        this.$store.dispatch("courseMappingFilters/clearEmployees");
        return;
      }

      if (loading) loading(true);
      this.excludeEmployeeSearchTimeout = setTimeout(async () => {
        try {
          // Independent BIB employee search for exclude list
          await this.$store.dispatch("courseMappingFilters/fetchEmployees", { search });
        } finally {
          if (loading) loading(false);
        }
      }, 350);
    },

    onExcludeEmployeeChange() {
      // No additional logic needed for employee level
    },

    clearExcludeFilters() {
      this.excludeFilters = {
        departments: [],
        positions: [],
        employees: []
      };
    },

    // Training methods
    async loadTrainings() {
      const params = {
        page: this.body.page,
        limit: this.body.limit,
        search: this.filters.search || ''
      };
      await this.$store.dispatch("courseMappingFilters/fetchTrainings", params);
    },

    async loadTrainingMapping() {
      const params = this.buildMappingParams();
      if (params) {
        await this.$store.dispatch("courseMappingFilters/fetchTrainingMapping", params);
      }
    },

    buildMappingParams() {
      const params = {};
      if (this.filters.division) params.division = this.filters.division;
      if (this.filters.department) params.department = this.filters.department;
      if (this.filters.position_id) params.positionId = this.filters.position_id;
      if (this.filters.name) params.nik = this.filters.name;
      return Object.keys(params).length > 0 ? params : null;
    },

    buildSaveMappingParams() {
      // Build parameters for PUT request (old format with mandatory_level and identifier)
      const params = {};
      const excludedIdentifiers = [];

      if (this.filters.name) {
        // Employee level
        params.mandatory_level = "employee";
        params.identifier = this.filters.name;
        // No exclusions at employee level (most specific)
      } else if (this.filters.position_id) {
        // Position level
        params.mandatory_level = "position";
        params.identifier = this.filters.position_id;
        // Exclude employees if selected
        if (this.excludeFilters.employees.length > 0) {
          excludedIdentifiers.push(...this.excludeFilters.employees);
        }
      } else if (this.filters.department) {
        // Department level
        params.mandatory_level = "department";
        params.identifier = this.filters.department;
        // Exclude positions and employees if selected
        if (this.excludeFilters.positions.length > 0) {
          excludedIdentifiers.push(...this.excludeFilters.positions);
        }
        if (this.excludeFilters.employees.length > 0) {
          excludedIdentifiers.push(...this.excludeFilters.employees);
        }
      } else if (this.filters.division) {
        // Division level
        params.mandatory_level = "division";
        params.identifier = this.filters.division;
        // Exclude departments, positions, and employees if selected
        if (this.excludeFilters.departments.length > 0) {
          excludedIdentifiers.push(...this.excludeFilters.departments);
        }
        if (this.excludeFilters.positions.length > 0) {
          excludedIdentifiers.push(...this.excludeFilters.positions);
        }
        if (this.excludeFilters.employees.length > 0) {
          excludedIdentifiers.push(...this.excludeFilters.employees);
        }
      } else {
        return null;
      }

      // Add excluded_identifiers if any
      if (excludedIdentifiers.length > 0) {
        params.excluded_identifiers = excludedIdentifiers;
      }

      return params;
    },

    isTrainingSelected(trainingId) {
      return this.$store.getters["courseMappingFilters/isTrainingSelected"](trainingId);
    },

    toggleTrainingSelection(trainingId) {
      this.$store.dispatch("courseMappingFilters/toggleTrainingSelection", trainingId);
    },

    toggleAllTrainings() {
      if (this.allTrainingsSelected) {
        // Unselect all
        this.$store.dispatch("courseMappingFilters/clearSelectedTrainings");
      } else {
        // Select all
        this.trainings.forEach(training => {
          if (!this.isTrainingSelected(training.id)) {
            this.$store.dispatch("courseMappingFilters/toggleTrainingSelection", training.id);
          }
        });
      }
    },

    async saveTrainingMapping() {
      try {
        const selectedTrainings = this.$store.getters["courseMappingFilters/getSelectedTrainings"];
        const mappingParams = this.buildSaveMappingParams();
        
        if (!mappingParams) {
          this.$swal("Error", "Pilih minimal satu level filter", "error");
          return;
        }
        
        if (selectedTrainings.length === 0) {
          this.$swal("Error", "Pilih minimal satu pelatihan", "error");
          return;
        }

        const data = {
          training_ids: selectedTrainings,
          ...mappingParams // Use old format with mandatory_level and identifier
        };

        await this.$store.dispatch("courseMappingFilters/saveTrainingMapping", data);
        
        this.$swal({
          title: "Success",
          text: "Mapping pelatihan berhasil disimpan",
          icon: "success",
          confirmButtonText: "OK"
        });
        
      } catch (error) {
        console.error("Error saving training mapping:", error);
        let errorMessage = "Error while saving training mapping";
        
        if (error.response && error.response.data) {
          const errorData = error.response.data;
          if (errorData.message) {
            errorMessage = errorData.message;
          } else if (errorData.error) {
            errorMessage = errorData.error;
          }
        }
        
        this.$swal("Error", errorMessage, "error");
      }
    },

    // Search with debounce
    onSearch() {
      // Clear existing timeout
      if (this.searchTimeout) {
        clearTimeout(this.searchTimeout);
      }
      
      // Debounce search
      this.searchTimeout = setTimeout(() => {
        if (this.showTrainingTable) {
          this.body.page = 1; // Reset to first page on search
          this.loadTrainings();
        }
      }, 500);
    },

    // Reset all filters and results to default state
    clearFilter() {
      this.filters = {
        division: "",
        department: "",
        name: "",
        position_id: "",
        course: "",
        search: ""
      };
      
      this.excludeFilters = {
        departments: [],
        positions: [],
        employees: []
      };

      this.body.page = 1;
      
      // Reload independent BIB filter options
      this.loadFilterOptions();
      this.$store.dispatch("courseMappingFilters/clearEmployees");
      this.$store.dispatch("courseMappingFilters/clearSelectedTrainings");
      
      this.showTrainingTable = false;
    },

    clearFilters() {
      this.clearFilter();
    },

    // Actions
    addData() {
      this.isAdd = true;
      this.modalTitle = "Add Course Mapping";
      this.resetAddForm();
      this.$bvModal.show("modal-course-mapping");
    },

    viewData(data) {
      this.isAdd = null; // View mode
      this.modalTitle = "View Course Mapping";
      this.viewDetailData = data;
      this.$bvModal.show("modal-course-mapping");
    },

    resetAddForm() {
      this.bodyAdd = {
        position_id: "",
        competency_id: "",
        role_id: "",
        required: false
      };
      this.$validator.reset();
    },

    // Save methods
    saveAdd() {
      this.$validator.validateAll().then(async (result) => {
        if (!result) return false;
        
        try {
          await this.$store.dispatch("courseMapping/createPositionCompetencyMapping", this.bodyAdd);
          this.$swal({
            title: "Success",
            text: "Course mapping berhasil ditambahkan",
            icon: "success",
            confirmButtonText: "OK"
          }).then(() => {
            this.getPositionCompetencyMappings();
            this.$bvModal.hide("modal-course-mapping");
            this.resetAddForm();
          });
        } catch (error) {
          console.log("Error response:", error);
          let errorMessage = "Error while adding course mapping";
          
          if (error.response && error.response.data) {
            const errorData = error.response.data;
            if (errorData.httpCode === 400 && errorData.error) {
              errorMessage = errorData.error;
            } else if (errorData.message) {
              errorMessage = errorData.message;
            } else if (errorData.httpMessage) {
              errorMessage = errorData.httpMessage;
            }
          }
          
          this.$swal("Error", errorMessage, "error");
        }
      });
    },

    // API calls
    getPositionCompetencyMappings() {
      const params = { ...this.body };
      if (this.filters.division) params.division = this.filters.division;
      if (this.filters.department) params.department = this.filters.department;
      if (this.filters.name) params.name = this.filters.name;
      if (this.filters.position_id) params.position_id = this.filters.position_id;
      if (this.filters.course) params.course = this.filters.course;
      if (this.filters.search) params.search = this.filters.search;
      
      this.$store.dispatch("courseMapping/getPositionCompetencyMappings", params);
    },

    getPositions() {
      this.$store.dispatch("position/getPositions", {
        limit: 100
      });
    },

    getCompetencies() {
      this.$store.dispatch("competency/getCompetencies", {
        limit: 100
      });
    },

    // Pagination
    onPageChange(payload) {
      this.body.limit = payload.currentPerPage;
      this.body.page = payload.currentPage;
      this.loadTrainings();
    },

    onPerPageChange(payload) {
      this.body.limit = payload.currentPerPage;
      this.body.page = 1;
      this.loadTrainings();
    },

    // Upload methods
    showUploadModal() {
      this.selectedFile = null;
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = '';
      }
      this.$bvModal.show('modal-upload');
    },

    onFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        // Validate file size (5MB max)
        if (file.size > 5 * 1024 * 1024) {
          this.$swal({
            title: 'Error',
            text: 'Ukuran file harus kurang dari 5MB',
            icon: 'error',
            confirmButtonText: 'OK'
          });
          event.target.value = '';
          return;
        }
        
        // Validate file type
        if (!file.name.toLowerCase().endsWith('.xlsx')) {
          this.$swal({
            title: 'Error',
            text: 'Hanya file .xlsx yang diizinkan',
            icon: 'error',
            confirmButtonText: 'OK'
          });
          event.target.value = '';
          return;
        }
        
        this.selectedFile = file;
      }
    },

    formatFileSize(bytes) {
      if (bytes === 0) return '0 Bytes';
      const k = 1024;
      const sizes = ['Bytes', 'KB', 'MB', 'GB'];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
    },

    async downloadTemplate() {
      if (this.isDownloading) return;

      this.isDownloading = true;

      try {
        const response = await this.$store.dispatch('courseMapping/downloadPositionCompetencyMappingTemplate');
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');

        link.href = url;
        link.setAttribute('download', 'Training Mapping Template.xlsx');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        this.$swal({
          title: 'Success',
          text: 'Template berhasil diunduh',
          icon: 'success',
          confirmButtonText: 'OK'
        });
      } catch (error) {
        console.error('Error downloading training mapping template:', error);
        this.$swal({
          title: 'Error',
          text: 'Template belum berhasil diunduh. Silakan coba lagi.',
          icon: 'error',
          confirmButtonText: 'OK'
        });
      } finally {
        this.isDownloading = false;
      }
    },

    async uploadFile() {
      if (!this.selectedFile) {
        this.$swal({
          title: 'Error',
          text: 'Pilih file yang akan diunggah',
          icon: 'error',
          confirmButtonText: 'OK'
        });
        return;
      }

      this.isUploading = true;
      
      try {
        const formData = new FormData();
        formData.append('file', this.selectedFile);
        
        const response = await this.$store.dispatch('courseMapping/uploadBulkMapping', formData);
        
        // Show detailed success message
        const data = response.data || {};
        const summary = data.summary || {};
        
        let successMessage = `
          <div class="text-left">
            <p><strong>Bulk Unggah Berhasil!</strong></p>
            <ul class="list-unstyled mb-0">
              <li>✓ Rows Processed: ${summary.rowsProcessed || 0}</li>
              <li>✓ Groups Processed: ${summary.groupsProcessed || 0}</li>
              <li>✓ Mappings Created: ${summary.mappingsCreated || 0}</li>
            </ul>
          </div>
        `;
        
        // Show warnings if any
        if (summary.validationErrors > 0 || summary.processingErrors > 0) {
          successMessage += `
            <div class="mt-2 text-warning">
              <small>
                ⚠ Validasi Gagals: ${summary.validationErrors || 0}<br>
                ⚠ Processing Errors: ${summary.processingErrors || 0}
              </small>
            </div>
          `;
        }
        
        await this.$swal({
          title: 'Success',
          html: successMessage,
          icon: 'success',
          confirmButtonText: 'OK'
        });
        
        // Close modal and refresh data
        this.$bvModal.hide('modal-upload');
        this.selectedFile = null;
        
        // Reload trainings if filters are applied
        if (this.showTrainingTable) {
          await this.loadTrainings();
          this.loadTrainingMapping();
        }
        
      } catch (error) {
        console.error('Upload error:', error);
        
        let errorMessage = 'File belum berhasil diunggah. Silakan coba lagi.';
        
        if (error.response && error.response.data) {
          const errorData = error.response.data;
          
          // Check for validation or processing errors
          if (errorData.data && (errorData.data.validationErrors || errorData.data.processingErrors)) {
            const validationErrors = errorData.data.validationErrors || [];
            const processingErrors = errorData.data.processingErrors || [];
            
            let errorDetails = '<div class="text-left"><ul class="mb-0">';
            
            validationErrors.forEach(err => {
              errorDetails += `<li>${err.message || err}</li>`;
            });
            
            processingErrors.forEach(err => {
              errorDetails += `<li>${err.message || err}</li>`;
            });
            
            errorDetails += '</ul></div>';
            
            this.$swal({
              title: 'Unggah Gagal',
              html: errorDetails,
              icon: 'error',
              confirmButtonText: 'OK'
            });
            return;
          }
          
          if (errorData.message) {
            errorMessage = errorData.message;
          } else if (errorData.error) {
            errorMessage = errorData.error;
          }
        }
        
        this.$swal({
          title: 'Error',
          text: errorMessage,
          icon: 'error',
          confirmButtonText: 'OK'
        });
      } finally {
        this.isUploading = false;
      }
    }
  }
};
